import { useContext, createContext } from 'react'

export const LayoutContext = createContext({
  loading: false,
  setLoading: () => null,
  forceRequireAccess: false,
  setForceRequireAccess: () => null,
})
export const useLayout = () => useContext(LayoutContext)
